var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyAccepted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2.00122H7.81C4.17 2.00122 2 4.17122 2 7.81122V16.1812C2 19.8312 4.17 22.0012 7.81 22.0012H16.18C19.82 22.0012 21.99 19.8312 21.99 16.1912V7.81122C22 4.17122 19.83 2.00122 16.19 2.00122ZM16.78 9.70122L11.11 15.3712C10.97 15.5112 10.78 15.5912 10.58 15.5912C10.38 15.5912 10.19 15.5112 10.05 15.3712L7.22 12.5412C6.93 12.2512 6.93 11.7712 7.22 11.4812C7.51 11.1912 7.99 11.1912 8.28 11.4812L10.58 13.7812L15.72 8.64122C16.01 8.35122 16.49 8.35122 16.78 8.64122C17.07 8.93122 17.07 9.40122 16.78 9.70122Z",
    fill: "url(#paint0_linear_3136_3815)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3136_3815",
    x1: 2,
    y1: 2.00122,
    x2: 24.8902,
    y2: 6.20345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyAccepted);
export default __webpack_public_path__ + "static/media/policyAccepted.78068b8628752e8127204ae4420c4640.svg";
export { ForwardRef as ReactComponent };